import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, CircularProgress } from "@mui/material";
import InlineIconButton from "../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { nullCheck } from "../../../../utils/dataHelpers";
import { CarrierService } from "../../../../services/CarrierService";
import { ActiveUserContext, AlertContext } from "../../../Dashboard/Dashboard";

export default function DeclinedMatchCell({ row, column, updateData }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const rowItem = nullCheck(row, null, "original");
  const activeUser = useContext(ActiveUserContext);

  const handleDecline = () => {
    const payload = {
      userId: activeUser.userIdMcld,
      carrierId: rowItem.carrierId.trim(),
      orderId: rowItem.orderId.trim(),
      dateRemoved: new Date().toISOString(),
      carrierOriginCity: rowItem.carrierOriginCity,
      carrierOriginState: rowItem.carrierOriginState,
      carrierName: rowItem.carrierName,
      movementId: rowItem.movementId,
      milesFromOrigin: rowItem.milesFromOrigin,
    };

    setIsLoading(true);
    CarrierService.CreateNetworkMatchingRemoved(instance, payload).then(() => {
      updateData(parseInt(row.id), column.id, true);
      setIsLoading(false);
    }).catch(error => {
      console.error(error);
      setIsLoading(false);
      warning(error);
    });
  };

  return (
    isLoading ? (
      <Box sx={{ display: "flex", justifyContent: "center" }} >
        <CircularProgress sx={{ color: "primary.60" }} size={20} />
      </Box >
    ) : (
      <StyledTooltip title="Decline">
        <Box
          sx={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "-2px" }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <InlineIconButton
            onClick={handleDecline}
            icon={HighlightOffIcon}
            buttonColor="red"
          />
        </Box>
      </StyledTooltip>
    ));
}

DeclinedMatchCell.propTypes = {
  row: PropTypes.object,
  column: PropTypes.object,
  updateData: PropTypes.func
};